// @ts-ignore:TODO

declare var ddo: any;

export class Report {
    // Adobe Event Action
    EVENT_ACTION: string = 'video';
    private oldEvent: string = '';
    private oldData: any = null;

    sendReport(event: string, finalObj: any, eventAction?: any) {
        console.log(
            'event : ',
            event,
            ' finalObj :',
            finalObj,
            'eventAction : ',
            eventAction,
        );
        // if ddo object from EDM is not present log it and return false
        if (typeof ddo === 'undefined') {
            console.log('ddo object is not present to report the media events.');
            return false;
        }

        // per Raymond Agnes request to enforce all data types as Strings...
        Object.keys(finalObj).forEach((key) => {
            finalObj[key] = finalObj[key]?.toString();
        });

        if (
            this.oldEvent &&
            this.oldData &&
            event === this.oldEvent &&
            JSON.stringify(finalObj) === JSON.stringify(this.oldData)
        ) {
            //  Debug.log('dublicate event reproting ignore');
            return false;
        } else {
            // calling adobe push event to send the report to EDM
            if (eventAction) {
                ddo.pushEvent(eventAction, event, finalObj);
            } else {
                ddo.pushEvent(this.EVENT_ACTION, event, finalObj);
            }
            this.oldData = finalObj;
            this.oldEvent = event;
            return true;
        }
    }

    getVideoControlAction(value: any) {
        let action = 'Enter';
        if (!value) {
            // do nothing
        } else if (value === 32) {
            // If it's the space key
            action = 'Spacebar';
        } else if (value === 37) {
            // If it's the left arrow key
            action = 'Left Arrow';
        } else if (value === 39) {
            // If it's the right arrow key
            action = 'Right Arrow';
        } else if (value === 27) {
            // If it's the escape key
            action = 'Escape';
        } else if (value === 1) {
            // If it's the mouse interaction
            action = 'Click';
        } else if (value === 0) {
            // If it's the touch
            action = 'Touch';
        } else if (value === 13) {
            // If it's the enter
            action = 'Enter';
        }
        return action;
    }
}
